<div class="card">
  @if (hasChart()) {
    <div class="chart-slot">
      <ng-content select="[chart]"></ng-content>
    </div>
  }
  @if (icon()) {
    <div class="icon-container">
      <mat-icon class="metric-icon">{{ icon() }}</mat-icon>
    </div>
  }
  <div class="card-top-header">
    <p class="subtitle">{{ title() }}</p>
  </div>
  <div class="card-center-content">
    <div class="card-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
